import type { Fallacy } from "./types";
import { createStory } from "./types";

export const gamblersFallacy: Fallacy = {
    id: "gamblers-fallacy",
    name: "Gambler's Fallacy",
    emoji: "🎲",
    category: "Manipulasi Statistik",
    description: "Meyakini **hasil acak sebelumnya** mempengaruhi hasil berikutnya, padahal setiap kejadian **bersifat independen**.",
    tldr: "Sudah 5x keluar merah, pasti berikutnya hitam — padahal peluangnya tetap sama.",
    detail: "Gambler's Fallacy adalah keyakinan keliru bahwa jika kejadian acak terjadi lebih sering dari biasanya, maka akan lebih jarang terjadi di masa depan, atau sebaliknya. Padahal, **setiap kejadian acak bersifat independen** — hasil sebelumnya **tidak mempengaruhi hasil berikutnya**.\n\nContoh klasik: jika koin jatuh di sisi kepala 10 kali berturut-turut, banyak orang yakin lemparan berikutnya 'pasti' ekor. Padahal peluangnya tetap 50-50. Koin tidak memiliki memori.\n\nKekeliruan ini berbahaya dalam perjudian dan investasi. 'Saham sudah turun 5 hari, pasti besok naik' — ini mengasumsikan adanya 'keseimbangan alam' yang mengoreksi hasil acak. **Alam semesta tidak berutang keberuntungan pada siapa pun.** Setiap kejadian acak berdiri sendiri.",
    story: createStory("Gambler's Fallacy", "🎲", {
      hook: {
        title: "Udah 5x keluar merah...",
        body: "\"Berikutnya pasti hitam dong!\" Yakin? Koin gak punya memori loh.",
      },
      convo: {
        claim: "IHSG udah merah 6 hari berturut-turut nih. Aku mau all-in karena **besok pasti ijo dong**, masa merah terus-terusan.",
        response: "Pasar gak punya memori. **Merah 6 hari bukan jaminan besok ijo.**",
      },
      reveal: {
        body: "Kamu percaya hasil acak sebelumnya **mempengaruhi yang berikutnya**. Padahal setiap kejadian acak itu **independen** — peluangnya tetap sama.",
      },
      insight: {
        title: "Alam semesta gak ngutang",
        body: "Koin yang jatuh kepala 10 kali? Lemparan berikutnya **tetap 50-50**. Gak ada \"giliran hoki\" — tiap kejadian acak berdiri sendiri.",
      },
      engagement: {
        title: "Pernah ngerasa \"udah waktunya hoki\"? 🎲",
        body: "Di gacha, investasi, atau interview kerja? **Share pengalaman kamu di komen!** 👇",
      },
    }),
    related: ["base-rate-fallacy", "post-hoc", "hasty-generalization"],
  };
